<template>
    <section class="cinema-swiper">
        <div class="title">{{ title }}</div>
        <div class="percom">
            <!-- 元素大于一组，展示SWIPER -->
            <div v-if="chunkLists($utils.hotData).length > 1" class="swiper-container"
                ref="swiperContainer"
            >
                <div class="swiper-wrapper">
                    <div v-for="(list, oIndex) in chunkLists($utils.hotData)" :key="oIndex"
                        class="swiper-slide"
                    >
                        <ul class="s-u-b clearfix">
                            <li class="p-l-b" v-for="(item, index) in list" :key="item.id" @click="linksToDetailHandler(item.movieInfo.id, item.movieInfo.member_type)">
                                <cinema-item :cinema="item" :index="index" :isBar="isBar"></cinema-item>
                            </li>
                        </ul>
                    </div>
                </div>

                <div v-show="swiperButton" class="swiper-button-prev"></div>
                <div v-show="swiperButton" class="swiper-button-next"></div>
            </div>
            <!-- 元素为一组，展示为普通列表 -->
            <div v-else class="swiper-slide"
                v-for="(list, oIndex) in chunkLists($utils.hotData)" :key="oIndex"
            >
                <ul class="s-u-b clearfix">
                    <li class="p-l-b" v-for="item in list" :key="item.id" @click="linksToDetailHandler(item.movieInfo.id, item.movieInfo.member_type)">
                        <cinema-item :cinema="item" :index="oIndex" :isBar="isBar"></cinema-item>
                    </li>
                </ul>
            </div>
        </div>
        <div class="mobice">
            <div class="m-s-b">
                <ul class="m-u-b clearfix"
                    :style="{'width': $utils.hotData.length * 210 + 'px'}"
                >
                    <li v-for="(item, index) in $utils.hotData" :key="index"
                        @click="linksToDetailHandler(item.id, item.member_type) "
                    >
                        <span class="subscript-tag" v-if="item.is_subscript == 1"></span>
                        <img class="m-opacity" width="100%" src="@/assets/images/home/opacity.png" />
                        <img class="m-cover" width="100%" :src="item.imgurl ? require(`@/assets/images/home/${item.imgurl}.jpg`) :(item.thumbnail ? item.thumbnail : require('@/assets/images/movies/Default_cover.png'))"
                        />
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CinemaItem from "@/components/Home/CinemaItem";

export default {
    name: "CinemaList",
    props: {
        isBar: Boolean,
        title: String
    },
    data() {
        return {
            curArray: []
        };
    },
    computed: {
        ...mapState({
            swiperButton: (state) => state.home.swiperButton,
            userMember: (state) => state.home.userMember
        }),
        chunkLists(){
            return function(array){
                let  list = [];
                for(let i = 0; i < array.length; i += 6){
                    list.push(array.slice(i, i + 6));
                };
                return list;
            };
        }
    },
    mounted(){
        const $this = this;
        if(
            Array.isArray(this.$utils.hotData) && this.$utils.hotData.length > 0
        ){
            this.$nextTick(() => {
                let mySwiper = new this.$swiper(this.$refs.swiperContainer, {
                    loop: false,
                    pagination: {
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                })
            })
        }
    },
    methods: {
        ...mapActions({
            SetSiginStatusFn: "SetSiginStatusFn",
            SetLoadShowFn: "SetLoadShowFn",
            addLoadShowFn:"addLoadShowFn",
            getDataNikkatsuFn: "getDataNikkatsuFn"
        }),
        linksToDetailHandler(id, member_type) {
            // 发送统计上报
            const sendDataNikkatsuFn = async() => {
                const result = await this.getDataNikkatsuFn( {up_type: 6} );
            }
            sendDataNikkatsuFn();

            if(!window.localStorage.getItem("token")){
                window.localStorage.setItem('path', `/serial/${id}?pid=${id}`);
                this.SetSiginStatusFn(true);
                return;
            }
            if((Object.keys(this.userMember).length > 0 && this.userMember.isVip == 1) || member_type == 1) {
              this.SetLoadShowFn(false);
              this.addLoadShowFn(true).then(res => {
                this.$router.push('/serial/' + id + '?pid=' + id)
              })
            } else {
                this.$router.push("/member");
            }
        }

    },

    components: {
        CinemaItem
    },
}
</script>
